import { useLang } from '@/i18n';
import styles from './index.module.scss';
import { useEffect, useState } from 'react';

let titleSceneD: any = null;
const D = () => {
    const { t } = useLang('delta_pro_ultra.launch.detail');
    const [textEnter, setTextEnter] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resizeAni = () => {
                if (titleSceneD) {
                    AniContainer.removeScene(titleSceneD);
                    titleSceneD = null;
                }

                titleSceneD = AniContainer.create({
                    triggerElement: '.dpu-detail-D .dpu-D-box',
                    triggerHook: 1,
                    offset: '50%',
                    duration: 200,
                    onEnter: () => {
                        setTextEnter(true);
                    },
                });
            };
            resizeAni();
            return () => {
                if (titleSceneD) {
                    AniContainer.removeScene(titleSceneD);
                    titleSceneD = null;
                }
            };
        }
    }, []);
    return (
        <section className={`dpu-detail-D dpu-detail-section ${styles.dpuDetailD}`}>
            <div className={`dpu-D-box ${textEnter ? 'enter' : ''}`}>
                <p className='title'>{t('secD_title')}</p>
            </div>
        </section>
    );
};

export default D;
